import { FunctionComponent, ReactNode } from "react";
import styles from "./DropdownTitleAtom.module.css";

export type DropdownTitleAtomType = {
  className?: string;
  title?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
};

const DropdownTitleAtom: FunctionComponent<DropdownTitleAtomType> = ({
  className = "",
  title,
  iconLeft,
  iconRight,
}) => {
  return (
    <div className={[styles.title, className, "quill-ui-next-atom"].join(" ")}>
      {iconLeft && <div className={styles.iconLeft}>{iconLeft}</div>}
      <div className={styles.title1}>{title}</div>
      <div className={styles.containerIconRight}>
        {iconRight && <div className={styles.iconRight}>{iconLeft}</div>}
      </div>
    </div>
  );
};

export default DropdownTitleAtom;
